import { apiClient } from '../client'
import type { ApiSuccessResponse } from '../../types/api'
import type { DoctorSignupFormData, DoctorSignupPayload } from '../../types/doctor'

export const doctorSignupService = {
  async getFormData() {
    const { data } = await apiClient.get<ApiSuccessResponse<DoctorSignupFormData>>(
      '/doctor/signup/form-data',
    )
    return data
  },

  async submit(payload: DoctorSignupPayload) {
    const formData = new FormData()
    formData.append('salutation', payload.salutation)
    formData.append('first_name', payload.first_name)
    formData.append('surname', payload.surname)
    formData.append('email', payload.email)
    if (payload.phone_number) {
      formData.append('phone_number', payload.phone_number)
    }
    formData.append('registration_number', payload.registration_number)
    formData.append('proposer_name', payload.proposer_name)
    formData.append('proposer_phone_number', payload.proposer_phone_number)
    formData.append('proposer_email', payload.proposer_email)
    formData.append('seconder_name', payload.seconder_name)
    formData.append('seconder_phone_number', payload.seconder_phone_number)
    formData.append('seconder_email', payload.seconder_email)
    if (payload.department_id) {
      formData.append('department_id', payload.department_id)
    }
    if (payload.new_department) {
      formData.append('new_department[name]', payload.new_department.name)
      if (payload.new_department.parent_id) {
        formData.append('new_department[parent_id]', payload.new_department.parent_id)
      }
      formData.append('new_department[is_active]', payload.new_department.is_active ? '1' : '0')
    }
    if (payload.position_id) {
      formData.append('position_id', payload.position_id)
    }
    if (payload.new_position) {
      formData.append('new_position[name]', payload.new_position.name)
      formData.append('new_position[is_active]', payload.new_position.is_active ? '1' : '0')
    }
    payload.hospital_ids?.forEach((id, index) => formData.append(`hospital_ids[${index}]`, id))
    payload.new_hospitals?.forEach((hospital, index) => {
      formData.append(`new_hospitals[${index}][name]`, hospital.name)
      if (hospital.address) {
        formData.append(`new_hospitals[${index}][address]`, hospital.address)
      }
      formData.append(`new_hospitals[${index}][is_active]`, hospital.is_active ? '1' : '0')
    })
    payload.documents.forEach((file, index) => formData.append(`documents[${index}]`, file))
    formData.append('terms_accepted', payload.terms_accepted ? '1' : '0')
    formData.append('privacy_accepted', payload.privacy_accepted ? '1' : '0')
    formData.append('terms_version', payload.terms_version)

    const { data } = await apiClient.post<ApiSuccessResponse<{ id: string; status: string }>>(
      '/doctor/signup',
      formData,
    )
    return data
  },
}
